import { TFunction } from 'i18next';
import {
  addHours,
  addMonths,
  addOneYear,
  calculateDaysBetween,
} from 'lib/utils/datetime';

export const EXTEND_DELETION_TYPES = {
  '1_DAY': '1_DAY',
  '1_WEEK': '1_WEEK',
  '2_WEEKS': '2_WEEKS',
  '1_MONTH': '1_MONTH',
  '3_MONTHS': '3_MONTHS',
  '6_MONTHS': '6_MONTHS',
  '1_YEAR': '1_YEAR',
  FOREVER: 'FOREVER',
  CUSTOM: 'CUSTOM',
};

export const getDropdownItems = (t: TFunction, initStartDate: Date) => [
  {
    id: EXTEND_DELETION_TYPES['1_DAY'],
    value: calculateDaysBetween(addHours(new Date(), 24)),
    label: t('timeframe.day_one'),
  },
  {
    id: EXTEND_DELETION_TYPES['1_WEEK'],
    value: calculateDaysBetween(addHours(new Date(), 168)),
    label: t('timeframe.week_one'),
  },
  {
    id: EXTEND_DELETION_TYPES['2_WEEKS'],
    value: calculateDaysBetween(addHours(new Date(), 336)),
    label: t('timeframe.week_two'),
  },
  {
    id: EXTEND_DELETION_TYPES['1_MONTH'],
    value: calculateDaysBetween(addMonths(new Date(), 1)),
    label: t('timeframe.month_one'),
  },
  {
    id: EXTEND_DELETION_TYPES['3_MONTHS'],
    value: calculateDaysBetween(addMonths(new Date(), 3)),
    label: t('timeframe.month_three'),
  },
  {
    id: EXTEND_DELETION_TYPES['6_MONTHS'],
    value: calculateDaysBetween(addMonths(new Date(), 6)),
    label: t('timeframe.month_six'),
  },
  {
    id: EXTEND_DELETION_TYPES['1_YEAR'],
    value: calculateDaysBetween(addOneYear(new Date())),
    label: t('timeframe.year_one'),
  },
  {
    id: EXTEND_DELETION_TYPES.FOREVER,
    value: null,
    label: t('timeframe.forever'),
  },
  {
    id: EXTEND_DELETION_TYPES.CUSTOM,
    value: calculateDaysBetween(initStartDate),
    label: t('timeframe.custom'),
  },
];
